import { render, staticRenderFns } from "./SlideNavigation.vue?vue&type=template&id=6b01c5b8&scoped=true&"
import script from "./SlideNavigation.vue?vue&type=script&lang=ts&"
export * from "./SlideNavigation.vue?vue&type=script&lang=ts&"
import style0 from "./SlideNavigation.vue?vue&type=style&index=0&id=6b01c5b8&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b01c5b8",
  null
  
)

export default component.exports